export default "__VITE_ASSET__9783a0ac__"